import type { Action, Store } from 'redux';
import type { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import type { RootState } from './reducer';

export type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction>;

export type AppStore = Store<RootState, Action> & { dispatch: AppDispatch };

let appStore: AppStore | undefined;

export const setAppStore = (store: AppStore): void => {
  appStore = store;
};

export const getAppStore = (): AppStore => {
  if (!appStore) throw new Error('App store accessed before initialisation');
  return appStore;
};

export const peekAppStore = (): AppStore | undefined => appStore;
